import http from './http';

const getDeletedWebsites = (value, page) => {
  const base = `/website?admin=admin&page_size=10&page_nbr=${page}&sort_field=created_at&sort_type=desc&status=deleted&confirm_deleted_todo=true`;
  const q = value && value.length > 0 ? `&query=${encodeURIComponent(value)}` : '';
  return http.get(`${base}${q}`);
};

const confirmDelete = (websiteId) => http.del(`/website/${websiteId}/confirm_delete`);

export default { getDeletedWebsites, confirmDelete };
export { getDeletedWebsites, confirmDelete };
